import React, { useRef, useState } from "react";
import { uploadFile } from "../api/uploadFile";
import ErrorModal from "./ErrorModal";

// Eén PDF = één Claude-call van een paar seconden, dus synchroon (geen job/
// polling zoals bij de Mediris-import) - het resultaat wordt niet opgeslagen,
// enkel als voorstel doorgegeven aan onParsed() voor het reviewscherm.
export default function InvoicePdfImportPanel({ onClose, onParsed }) {
  const [dragOver, setDragOver] = useState(false);
  const [busy, setBusy] = useState(false);
  const [errorModal, setErrorModal] = useState({ show: false, message: "" });
  const fileInputRef = useRef(null);

  const startUpload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const result = await uploadFile("/invoices/parse-pdf", file);
      onParsed(result);
    } catch (err) {
      setBusy(false);
      setErrorModal({ show: true, message: err.message || "Fout bij uitlezen van de factuur." });
    } finally {
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) startUpload(file);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) startUpload(file);
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      {errorModal.show && (
        <ErrorModal
          message={errorModal.message}
          onClose={() => setErrorModal({ show: false, message: "" })}
        />
      )}

      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
          <h2 className="text-lg font-bold text-gray-800">Importeer factuur (PDF)</h2>
          <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl leading-none">
            ×
          </button>
        </div>

        <div className="p-5">
          <div
            onDrop={handleDrop}
            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onClick={() => !busy && fileInputRef.current?.click()}
            className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition ${
              dragOver ? "border-blue-500 bg-blue-50" : "border-gray-300 hover:border-gray-400"
            } ${busy ? "opacity-50 pointer-events-none" : ""}`}
          >
            <input
              ref={fileInputRef}
              type="file"
              accept=".pdf"
              onChange={handleFileChange}
              className="hidden"
            />
            <p className="text-sm text-gray-600">
              Sleep de PDF van een aankoopfactuur hierheen, of klik om te bladeren.
            </p>
            <p className="text-xs text-gray-400 mt-1">
              De factuur wordt uitgelezen en voorgesteld ter controle — er wordt niets automatisch opgeslagen.
            </p>
          </div>

          {busy && (
            <div className="mt-4 flex items-center justify-center gap-3 text-sm text-gray-600">
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
              Factuur wordt uitgelezen...
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
